import React, { useState } from "react";
import { Helmet } from "react-helmet";
import Header from "../../components/common/Header";
import Footer from "../../components/common/Footer";
import HeroSection from "./HeroSection";
import CollectionGrid from "./CollectionGrid";
import LabServicesAccordion from "./LabServicesAccordion";
import { biospecimenCategories, features, labServices } from "./data"; // Data ko alag file mein rakhna behtar hai
import ProcurementJourney from "./ProcurementJourney";

import ContactSection from "../../components/common/ContactSection";
import AnviyaFeatures from "../../components/common/AnviyaFeatures";

const Home = () => {
  // Changed: Initial state is null (nothing open)
  const [openIndex, setOpenIndex] = useState(null);

  const toggleExpanded = (index) => {
    // If clicking the same item, close it (null). Otherwise, open the new index.
    setOpenIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <>
      <Helmet>
        <title>ANVIYA Biospecimen Services</title>
      </Helmet>

      <main className="w-full bg-white">
        <Header />

        <HeroSection />

        <CollectionGrid categories={biospecimenCategories} />
        <ProcurementJourney />
        {/* Journey section code can also be moved to a separate component */}

        <LabServicesAccordion
          services={labServices}
          openIndex={openIndex} // Renamed prop for clarity
          onToggle={toggleExpanded}
        />
        <AnviyaFeatures
          title="Why Leading Researchers and
Patients Choose ANVIYA"
          features={features}
          buttonText="Book Now"
        />
        <ContactSection />
        <Footer />
      </main>
    </>
  );
};

export default Home;
